__turbopack_context__.v({
  "container": "order-details-scroll-bar-module-scss-module__-rgC3a__container",
  "continue-button": "order-details-scroll-bar-module-scss-module__-rgC3a__continue-button",
  "need-help": "order-details-scroll-bar-module-scss-module__-rgC3a__need-help",
  "pdp-footer": "order-details-scroll-bar-module-scss-module__-rgC3a__pdp-footer",
  "price": "order-details-scroll-bar-module-scss-module__-rgC3a__price",
  "price-continue": "order-details-scroll-bar-module-scss-module__-rgC3a__price-continue",
  "price-text": "order-details-scroll-bar-module-scss-module__-rgC3a__price-text",
  "text-bold": "order-details-scroll-bar-module-scss-module__-rgC3a__text-bold",
  "text-light": "order-details-scroll-bar-module-scss-module__-rgC3a__text-light",
});
